// Presentation and consent attestation only. The server validates frozen terms.
export const MORNING_RENEWAL_TIMING = 'last_scheduled_day_morning_v1';
export const CONSUMPTION_RENEWAL_TIMING = 'after_consumption';

export const cycleRenewalTiming = (record = {}) => {
  const snapshot = record?.planSnapshot;
  // A purchased snapshot owns its timing, including the legacy missing-field default.
  const timing = (snapshot ? snapshot.renewalTiming : record?.renewalTiming)
    ?? CONSUMPTION_RENEWAL_TIMING;
  if (![MORNING_RENEWAL_TIMING, CONSUMPTION_RENEWAL_TIMING].includes(timing)) return null;
  if (snapshot && record?.renewalTiming != null && record.renewalTiming !== timing) return null;
  return timing;
};

export const matchingCycleRenewalTerms = (plan, hold) => {
  const timing = cycleRenewalTiming(plan);
  return timing !== null && timing === cycleRenewalTiming(hold);
};
